<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div class="text-gray-700 text-sm">
      <div class="text-green-700 mb-2">手動で変更された項目名と値</div>
      <div class="border border-green-700">
        <div class="bg-green-700 text-white font-bold px-4 py-2 text-center">{{ target.categoryName }}</div>

        <!-- 日常・管理の場合 -->
        <div v-if="['3','4'].includes(target.categoryCode)">
          <div v-for="(row, i) in list" :key="'l'+i" class="p-2 border border-green-700">
            <!-- 内容 -->
            <div class="font-bold text-green-700">●{{ row.name }}</div>

            <div class="p-2 table">
              <div v-for="(l, i) in row.list" :key="'ll'+i" class="my-4 table-row">
                <div class="table-cell">{{ l.name }}</div>
                <div class="table-cell"> ： {{ l.val }}</div>
              </div>
            </div>

            <!-- 内容を変更するために変更した -->
            <div v-if="row.isChange" class="border border-gray-400 rounded p-2 ">
              <div class="text-xs mb-1 font-bold">※表の「内容」を変更するために<span class="bg-yellow-200">黄色</span>の箇所が変更されています。</div>
              <div class="text-xs mb-2 font-bold">※「単価1」は下記内容をもとに自動計算しています。</div>
              <div class="flex">
                <div class="mr-5">
                  週
                  <NumericTextInput
                    name="dispTimes"
                    v-model="row.isChange['dispTimes']"
                    class="w-20 text-right focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500"
                    :decimalPlace="row.isChange['dispTimes']&&!Number.isInteger(Number(row.isChange['dispTimes']))?decimal1 : 0"
                    :class="setBgColor(row.isChange['dispTimesBgColor'])"
                  />
                  回
                </div>
                <div class="mr-5">
                  <NumericTextInput
                    name="dispHours"
                    v-model="row.isChange['dispHours']"
                    class="w-20 text-right focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500"
                    :format="false"
                    :class="setBgColor(row.isChange['dispHoursBgColor'])"
                  />
                  時間
                </div>
                <div class="mr-5">
                  <NumericTextInput
                    name="dispPeople"
                    v-model="row.isChange['dispPeople']"
                    class="w-20 text-right focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500"
                    :decimalPlace="row.isChange['dispPeople']&&!Number.isInteger(Number(row.isChange['dispPeople']))?decimal1 : 0"
                    :class="setBgColor(row.isChange['dispPeopleBgColor'])"
                  />
                  名
                </div>
                <div>
                  <NumericTextInput
                    name="dispWage"
                    v-model="row.isChange['dispWage']"
                    class="w-20 text-right focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500"
                    :decimalPlace="row.isChange['dispWage']&&!Number.isInteger(Number(row.isChange['dispWage']))?decimal1 : 0"
                    :class="setBgColor(row.isChange['dispWageBgColor'])"
                  />
                  円/時間
                </div>
              </div>
            </div>

            <!-- 表を直接変更している -->
            <div v-if="row.table">
              {{ row.table }}
            </div>
          </div>

        </div>
        <!-- 日常・管理以外 -->
        <div v-else class="p-2 table">
          <div v-for="(row, i) in list" :key="'l'+i" class="my-4 table-row">
            <div class="table-cell">{{ row.name }}</div>
            <div class="table-cell"> ： {{ row.val }}</div>
          </div>
        </div>

        <!-- RLSプラス定期清掃の表で変更ある場合 -->
        <div v-if="isChange&&target.categoryCode=='2'" class="text-xs mt-3 p-2">
          <div class="font-bold">定期清掃 300㎡超え 詳細（<span class="bg-yellow-200">黄色</span>の箇所が手動変更）</div>
          <table class="table-fixed table border border-blue-400">
            <thead>
              <tr class="bg-blue-50">
                <th class="p-2 border-r">作業部位</th>
                <th colspan="2" class="p-2 border-r">数量</th>
                <th class="p-2 border-r">基本単価</th>
                <th class="p-2 border-r">項目による係数</th>
                <th class="p-2 border-r">単価</th>
                <th class="p-2">合計（数量×単価）</th>
              </tr>
            </thead>
            <tr v-for="(row, i) in target.subItemModalData.displayFixed" :key="'df'+i">
              <!-- 内容 定期清掃 -->
              <td class="p-2 border-r">{{ row.name }}</td>
              <td class="pl-2">{{ row.qty }}</td>
              <td class="pr-2 border-r">{{ row.unitName }}</td>
              <td class="p-2 text-center border-r" :class="row.priceKindBgColor?'bg-yellow-300':''">{{ row.priceKind }}</td>
              <td class="p-2 border-r">{{ row.kindCoef }}</td>
              <td class="p-2 text-center border-r">{{ row.price }}</td>
              <td class="p-2 text-center">{{ row.total }}</td>
            </tr>
          </table>
        </div>

        <!-- 定期清掃の表で変更ある場合 -->
        <div v-if="isChange&&['5','28'].includes(target.categoryCode)" class="text-xs mt-3 p-2">
          <div class="font-bold">300㎡超え 詳細（<span class="bg-yellow-200">黄色</span>の箇所が手動変更）</div>
          <table class="table-fixed table border border-blue-400">
            <thead>
              <tr class="bg-blue-50">
                <th class="p-2 border-r">内容</th>
                <th colspan="2" class="p-2 border-r">数量</th>
                <th class="p-2 border-r">基本単価</th>
                <th class="p-2 border-r">項目による係数</th>
                <th class="p-2">単価１</th>
              </tr>
            </thead>
            <tr v-for="(row, i) in target.subItemModalData.display" :key="'df'+i">
              <td class="p-2 border-r">{{ row.name }}</td>
              <td class="pl-2">{{ row.qty }}</td>
              <td class="pr-2 border-r">{{ row.unitName }}</td>
              <td class="p-2 text-center border-r" :class="row.priceKindBgColor?'bg-yellow-200':''">{{ row.priceKind }}</td>
              <td class="p-2 border-r">{{ row.kindCoef }}</td>
              <td class="p-2 text-center" :class="row.detailBgColor?'bg-yellow-200':''">{{ row.price }}</td>
            </tr>
          </table>
        </div>

        <!-- 特別清掃の表で変更ある場合 -->
        <div v-else-if="isChange&&['14'].includes(target.categoryCode)" class="text-xs mt-3 p-2">
          <div class="font-bold">詳細（<span class="bg-yellow-200">黄色</span>の箇所が手動変更）</div>
          <table class="table-fixed table border border-blue-400">
            <thead>
              <tr class="bg-blue-50">
                <th class="p-2 border-r">内容</th>
                <th colspan="2" class="p-2 border-r">数量</th>
                <th class="p-2 border-r">基本単価</th>
                <th class="p-2 border-r">オーナー係数</th>
                <th class="p-2 border-r">竣工係数</th>
                <th class="p-2 border-r">÷ 協力費係数</th>
                <th class="p-2">単価１</th>
              </tr>
            </thead>
            <tr v-for="(row, i) in target.subItemModalData.display" :key="'df'+i">
              <td class="p-2 border-r">{{ row.name }}</td>
              <td class="pl-2">{{ row.qty }}</td>
              <td class="pr-2 border-r">{{ row.unitName }}</td>
              <td class="p-2 text-center border-r" :class="row.priceKindBgColor?'bg-yellow-200':''">{{ row.priceKind }}</td>
              <td class="p-2 text-center border-r" :class="row.ownerBgColor?'bg-yellow-200':''">{{ row.owner }}</td>
              <td class="p-2 text-center border-r" :class="row.finishPointBgColor?'bg-yellow-200':''">{{ row.finishPoint }}</td>
              <td class="p-2 text-center border-r" :class="row.compeBgColor?'bg-yellow-200':''">{{ row.compe }}</td>
              <td class="p-2 text-center" :class="row.detailBgColor?'bg-yellow-200':''">{{ row.price }}</td>
            </tr>
          </table>
        </div>

        <!-- 定期・特別清掃以外の表で変更ある場合 -->
        <div v-else-if="isChange" class="text-xs mt-3 p-2">
          <div class="font-bold">詳細（<span class="bg-yellow-200">黄色</span>の箇所が手動変更）</div>
          <table class="table-fixed table border border-blue-400">
            <thead>
              <tr class="bg-blue-50">
                <th class="p-2 border-r">内容</th>
                <th colspan="2" class="p-2 border-r">数量</th>
                <th class="p-2 border-r" v-if="['23', '24', '25', '30'].includes(target.categoryCode)">基本単価</th>
                <th class="p-2 border-r" v-if="['23', '24', '25', '30'].includes(target.categoryCode)">オーナー係数</th>
                <th class="p-2 border-r" v-if="['23', '24', '25', '30'].includes(target.categoryCode)">÷ 協力費係数</th>
                <th class="p-2">単価１</th>
              </tr>
            </thead>
            <tr v-for="(row, i) in target.subItemModalData.display" :key="'df'+i">
              <td class="p-2 border-r">{{ row.name }}</td>
              <td class="pl-2">{{ row.qty }}</td>
              <td class="pr-2 border-r">{{ row.unitName }}</td>
              <td v-if="['23', '24', '25', '30'].includes(target.categoryCode)" class="p-2 text-center border-r" :class="row.priceKindBgColor?'bg-yellow-200':''">{{ row.priceKind }}</td>
              <td v-if="['23', '24', '25', '30'].includes(target.categoryCode)" class="p-2 text-center border-r" :class="row.ownerBgColor?'bg-yellow-200':''">{{ row.owner }}</td>
              <td v-if="['23', '24', '25', '30'].includes(target.categoryCode)" class="p-2 text-center border-r" :class="row.compeBgColor?'bg-yellow-200':''">{{ row.compe }}</td>
              <td class="p-2 text-center" :class="row.detailBgColor?'bg-yellow-200':''">{{ row.price }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import NumericTextInput from '@components/NumericTextInput.vue'
// import PrimaryButton from '@components/PrimaryButton.vue'
import { conf, price, other, setRLSplus } from '@libs/constantsEstimate'
export default {
  components: {
      Modal,
      NumericTextInput
      // PrimaryButton,
  },

  props: ['open', 'target'],

  data() {
    return {
      list: [],
      // 定期清掃の表で変更がある場合
      // 日常、管理で「内容は直接変更できません。変更したい場合は、こちらにご記入ください。」を変更している場合
      isChange: false
    }
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      }
    }
  },

  methods: {
    async getData() {
      console.log(this.target.subItemModalData)
      this.list = []
      // 日常・管理の場合
      if (['3', '4'].includes(this.target.categoryCode)) {
        this.normalMgt(this.target.subItemModalData)

      } else if (this.target.subItemModalData) {
        const item = this.target.subItemModalData

        // 式
        const confList = this.getChangeItem(item.conf, conf)
        const priceList = this.getChangeItem(item.price, price)
        const otherList = this.getChangeItem(item, other)
        // 連結
        this.list = confList.concat(priceList).concat(otherList)
        // ラウンドプラスの場合並べ替え
        if (this.target.categoryCode == '2') {
          this.sortRlsPlus()
          this.isChangefixedDisp(item)
        }

        this.isChangefixedDisp2(item)
        this.isChangeSp(item)
        this.isChangeOther(item)
      }
    },

    /**
     * 日常・管理用
     */
    normalMgt(subItemModalData) {
      const res = []
      if (subItemModalData && subItemModalData.modalTabData && subItemModalData.modalTabData.length) {
        // タブごとに変更箇所を取得
        for (let i = 0; i < subItemModalData.modalTabData.length; i++) {
          const item = subItemModalData.modalTabData[i].data
          const id = 'modalTab' + subItemModalData.modalTabData[i].id
          let name = ''

          const confList = this.getChangeItem(item.conf, conf)
          const priceList = this.getChangeItem(item.price, price)
          const otherList = this.getChangeItem(item, other)

          const list = confList.concat(priceList).concat(otherList)

          // 内容反映の項目を変更している場合
          let isChange = null
          if (item.conf) {
            if (item.conf.dispTimesBgColor || item.conf.dispHoursBgColor || item.conf.dispPeopleBgColor || item.conf.dispWageBgColor) {
              isChange = item.conf
            }
          }

          let table = null
          for (let j = 0; j < subItemModalData.display.length; j++) {
            const dis = subItemModalData.display[j]
            const disId = dis.type
            if (id == disId) {
              name = dis.name
              if (name) {
                name = name.replace('\r\n', '')
              }
              // 表を直接編集している
              if (!isChange && dis.detailBgColor) {
                table = `「単価1」を手動で直接編集しています（過去仕様）：${dis.price ? Number(dis.price).toLocaleString() : ''} 円`
              }
            }
          }

          if (list.length || isChange || table) {
            res.push({ name, id, list, isChange, table })
          }
        }
        this.list = res
      }
    },

    /**
     * 手動で変更された名前と値を取得
     * @param items 対象データ
     * @param names 項目名オブジェクト
     */
    getChangeItem(items, names) {
      const res = []
      if (items) {
        for (let i = 0; i < Object.keys(items).length; i++) {
          const key = Object.keys(items)[i]
          if (key.indexOf('BgColor') > -1 && items[key]) {
            let prop = key.replace('BgColor', '')

            if (this.target.categoryCode == '29' && key == 'dailycleaningBgColor') {
              prop = 'cleaning'
            }

            let name = names[prop]
            let val = items[prop]

            if (name) {
              // ラウンドプラウの場合
              if (this.target.categoryCode == '2') {
                // 単価の場合
                if (prop.indexOf('unitPrice') > -1 || prop.indexOf('exceed300Price') > -1) {
                  console.log('単価です！' + key + '⇒' + prop)
                  console.log(items.unitPrice)
                  if (items.unitPrice) {
                    if (prop == 'unitPriceRls') {
                      val = items.unitPrice['rls']
                    } else if (prop == 'unitPriceNormal') {
                      val = items.unitPrice['normal']
                    } else if (prop == 'unitPriceFixed') {
                      val = items.unitPrice['fixed']
                    } else if (prop == 'exceed300Price') {
                      val = items['exceed300Price']
                    }
                  }
                } else {
                  if (prop == 'owner') {
                    val = items['ownerRls']
                  }
                  name = setRLSplus(prop, name)
                }
              }

              res.push({
                // 項目名
                name ,
                // 値
                val
              })
            }
          }
        }
      }
      return res
    },

    /**
     * ラウンドプラス並べかえ
     */
    sortRlsPlus() {
      const ob = [
        { name: 'RLS', data: [] },
        { name: '固定清掃', data: [] },
        { name: '定期清掃', data: [] }
      ]
      for (let i = 0; i < this.list.length; i++) {
        const row = this.list[i]
        for (let j = 0; j < ob.length; j++) {
          const o = ob[j]
          if (row.name.indexOf(o.name) > -1) {
            o.data.push(row)
          }
        }
      }
      let res = []
      for (let i = 0; i < ob.length; i++) {
        const row = ob[i]
        if (row.data.length) {
          res = res.concat(row.data)
        }
      }
      this.list = res
    },

    /**
     * RLSプラスの定期清掃の300㎡超えで価格を変更している場合
     */
    isChangefixedDisp(items) {
      this.isChange = false
      if (items.displayFixed && items.displayFixed.length) {
        this.isChange = items.displayFixed.some(row => row.priceKindBgColor)
      }
    },

    /**
     * 定期清掃の300㎡超えで価格を変更している場合
     */
    isChangefixedDisp2(items) {
      this.isChange = false
      let flg = false

      if (['5', '28'].includes(this.target.categoryCode)) {
        if (items.selectedValue && items.selectedValue.length && items.selectedValue[1] == '3') {
          flg = true
        } else if (items.conf && items.conf.meter == '3') {
          flg = true
        }
      }

      // 300㎡越えの場合のみ、変更ありか確認
      if (flg && items.display && items.display.length) {
        this.isChange = items.display.some(row => row.priceKindBgColor)
      }
    },

    /**
     * 特別清掃で変更している場合
     */
    isChangeSp(item) {
      if (['14'].includes(this.target.categoryCode)) {
        this.isChange = false

        if (item.display && item.display.length) {
          for (let i = 0; i < item.display.length; i++) {
            const row = item.display[i]
            // 照明器具清掃で「箇所不明」の計算式の単価を変更している場合
            if (row.lightingTab && row.lightingUnitBgColor) {
              this.list.push({ name: '照明器具清掃単価', val: row.lightingUnit })
            }

            // 表のどこかを変更している場合
            if (row.compeBgColor || row.detailBgColor || row.finishPointBgColor || row.ownerBgColor || row.priceKindBgColor) {
              this.isChange = true
            }
          }
        }
      }
    },

    /**
     * その他作業で変更している場合
     */
    isChangeOther(item) {
      if (!['5', '28', '14'].includes(this.target.categoryCode)) {
        this.isChange = false

        if (item.display && item.display.length) {
          for (let i = 0; i < item.display.length; i++) {
            const row = item.display[i]
            // 表のどこかを変更している場合
            if (row.compeBgColor || row.detailBgColor || row.finishPointBgColor || row.ownerBgColor || row.priceKindBgColor) {
              this.isChange = true
              return
            }
          }
        }
      }
    },

    /**
     * 色設定
     */
    setBgColor(target) {
      if (target) {
        return 'bg-yellow-200'
      }
    },

    /**
     * モーダル閉じる
     */
    closed() {
      this.$emit('close')
      this.list = []
      this.isChange = false
    }
  }
}
</script>
<style scoped>
</style>